import React, { useState, useEffect } from "react";
import "../styles/styles.css";
import "../styles/customstyle.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import NavbarStandard from "../components/NavbarStandard";
import FooterStandard from "../components/FooterStandard";

const PrototypesPage = () => {
  const [passwordInput, setPasswordInput] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Prototype Class 1
  const cardData1 = [
    {
      title: "First Close Circle Launch",
      version: "v1.1",
      link: "https://www.figma.com/proto/8EssU3rnNgcIljzemhHNqP/Ojire-Playground?node-id=0-1&node-type=canvas&viewport=-32874%2C-5883%2C0.6&t=PxUHktZCMYrc47li-0&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=3714%3A28982&show-proto-sidebar=1https://www.figma.com/proto/8EssU3rnNgcIljzemhHNqP/Ojire-Playground?node-id=3714-28982&node-type=canvas&viewport=-32874%2C-5883%2C0.6&t=PxUHktZCMYrc47li-0&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=3714%3A28982&hide-ui=1",
    },
    {
      title: "Revamp January",
      version: "v1.2",
      link: "https://www.figma.com/proto/P6lTyBN06vBMPgMRgrgm7U/Ojire-Anywhere-Prototypes?page-id=140%3A999&node-id=580-57786&node-type=frame&viewport=908%2C635%2C0.86&t=O0D0EUWX6HJOrrKQ-8&scaling=scale-down&content-scaling=fixed&starting-point-node-id=580%3A57786&hide-ui=1",
    },
  ];

  // Prototype Class 2
  const cardData2 = [
    {
      title: "General Overview",
      version: "v1.1",
      link: "https://www.figma.com/proto/K9uf9CMxmIZkcVaCVYyHNv/Ojire-Back-Office-Prototypes?page-id=0%3A1&node-id=1-5277&node-type=canvas&viewport=804%2C1066%2C0.16&t=gkxLk5sStWBmtBNZ-8&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=1%3A5277&disable-default-keyboard-nav=1&hide-ui=1",
    },
    {
      title: "Merchant Onboarding Process",
      version: "v1.1",
      link: "https://www.figma.com/proto/K9uf9CMxmIZkcVaCVYyHNv/Ojire-Back-Office-Prototypes?page-id=1%3A12351&node-id=1-13708&node-type=section&viewport=885%2C747%2C0.09&t=mO5x2DunjsGdaJWy-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=1%3A13708&share=1",
    },
    {
      title: "Bank Reconciliation",
      version: "v1.1",
      link: "https://www.figma.com/proto/K9uf9CMxmIZkcVaCVYyHNv/Ojire-Back-Office-Prototypes?page-id=1%3A12351&node-id=1-12424&node-type=section&viewport=885%2C747%2C0.09&t=mO5x2DunjsGdaJWy-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=1%3A12424&share=1",
    },
    {
      title: "Add New Role & Ojirian",
      version: "v1.1",
      link: "https://www.figma.com/proto/K9uf9CMxmIZkcVaCVYyHNv/Ojire-Back-Office-Prototypes?page-id=1%3A12351&node-id=1-14446&node-type=section&viewport=885%2C747%2C0.09&t=mO5x2DunjsGdaJWy-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=1%3A14446&share=1",
    },
  ];

  // For logging in to the repository
  const checkPassword = () => {
    if (passwordInput === "ojire123") {
      setIsAuthenticated(true);
      setErrorMessage("");
    } else {
      setErrorMessage("Kata sandi salah, silakan coba lagi.");
    }
  };

  const createCard = (data) => (
    <div
      className="card-rep"
      key={data.link}
      onClick={() => window.open(data.link, "_blank")}
    >
      <h4 className="card-title-rep">{data.title}</h4>
      <p className="card-version-rep">{data.version}</p>
    </div>
  );

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        checkPassword();
      }
    };

    const passwordInputElement = document.getElementById("rep-password-input");
    passwordInputElement?.addEventListener("keypress", handleKeyPress);
    return () => {
      passwordInputElement?.removeEventListener("keypress", handleKeyPress);
    };
  }, [passwordInput]);

  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <meta
            name="keywords"
            content="UMKM, Payment, kasir, invoice, Merchant, toko, digital, pembayaran, QRIS"
          />
          <title>Ojire Anywhere | Prototypes</title>
        </Helmet>
        <div id="page-top">
          {/* Navigation */}
          <NavbarStandard isAuthenticated={isAuthenticated} />

          {!isAuthenticated ? (
            <div
              id="rep-password-container"
              className="text-password-container-rep"
            >
              <input
                type="password"
                id="rep-password-input"
                placeholder="Masukkan Kata Sandi"
                className="styled-input-rep"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
              />
              <button onClick={checkPassword} className="styled-button-rep">
                Masuk
              </button>
              {errorMessage && (
                <p id="rep-error-message" className="error-message-pw-rep">
                  {errorMessage}
                </p>
              )}
            </div>
          ) : null}

          <div
            id="rep-main-content"
            className={`page-section ${
              isAuthenticated ? "" : "blurred-rep no-select"
            }`}
          >
            <div className="container text-center-rep">
              <h1 className="text-primary text-padding-title-rep">
                Selamat Datang di Repositori Prototype Ojire
              </h1>
              <h4 className="step-description text-margin-subtitle-rep">
                Silahkan Klik Kartu Untuk Mengakses Prototype
              </h4>
              <h3 className="step-description text-margin-section-rep">
                <span className="header-yellow">Ojire Anywhere</span>
              </h3>
              <div id="cards-container1" className="cards-container-rep">
                {cardData1.map((data, index) => createCard(data))}
              </div>
              <h3 className="step-description text-margin-section-rep">
                <span className="header-yellow">
                  Ojire Back Office Dashboard
                </span>
              </h3>
              <div id="cards-container2" className="cards-container-rep">
                {cardData2.map((data, index) => createCard(data))}
              </div>
            </div>
          </div>

          {/* Footer */}
          <FooterStandard isAuthenticated={isAuthenticated} />
          {/* Footer*/}
        </div>
      </div>
    </HelmetProvider>
  );
};

export default PrototypesPage;
